import { AlertTriangle, FileText } from "lucide-react";
import { formatPriceCents } from "@/components/services/service-meta";
import { cn } from "@/lib/cn";

type Ficha = {
  id: string;
  name: string;
  lines: unknown[];
  custo: { totalCents: number; emAberto: boolean; semPreco: string[] };
};

/**
 * As fichas do par, lado a lado.
 *
 * Era um `<select>`, e com ele não dava pra comparar: pra saber que "BioCrown" custa menos que
 * "BioCrown Diamond" era preciso abrir uma, ler, abrir a outra. É o mesmo padrão que a produção
 * já usa em `MateriaisDoServico` — lá a pessoa escolhe a ficha vendo nome e tamanho de cada uma.
 */
export function FichaTecnicaSeletor({
  fichas,
  fichaId,
  onEscolher,
}: {
  fichas: Ficha[];
  fichaId: string | null;
  onEscolher: (id: string) => void;
}) {
  if (fichas.length === 0) return null;

  return (
    <div>
      <p className="mb-1 block text-xs font-medium text-zinc-600 dark:text-muted-foreground">
        Fichas deste material <span className="text-zinc-400">({fichas.length})</span>
      </p>
      <div className="flex flex-wrap gap-1.5">
        {fichas.map((f) => {
          const ativa = f.id === fichaId;
          return (
            <button
              key={f.id}
              type="button"
              onClick={() => onEscolher(f.id)}
              className={cn(
                "flex items-center gap-1.5 rounded-md border px-2.5 py-1.5 text-left text-xs transition-colors",
                ativa
                  ? "border-brand-300 bg-brand-50 font-semibold text-brand-700 dark:border-primary/40 dark:bg-primary/10 dark:text-primary"
                  : "border-zinc-200 bg-white text-zinc-600 hover:border-brand-300 dark:border-border dark:bg-card dark:text-muted-foreground",
              )}
            >
              <FileText className="h-3.5 w-3.5 shrink-0 opacity-70" />
              <span className="truncate">{f.name}</span>
              <span className="shrink-0 text-[10.5px] opacity-70">
                {f.lines.length} {f.lines.length === 1 ? "item" : "itens"}
                {f.custo.emAberto ? " · +" : ` · ${formatPriceCents(f.custo.totalCents)}`}
              </span>
              {f.custo.semPreco.length > 0 && (
                <AlertTriangle className="h-3 w-3 shrink-0 text-amber-500" />
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
}
